import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import { intlShape } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import * as validators from '../../util/validators';
import { SWEDISH_PHONE_PREFIX } from '../../util/phoneNumber';

import { FieldPhoneNumberInput } from '../../components';

const UserFieldPhoneNumber = props => {
  const { rootClassName, className, formId, formName, userTypeConfig, intl } = props;

  const { displayInSignUp, required } = userTypeConfig?.phoneNumberSettings || {};
  const isDisabled = userTypeConfig?.defaultUserFields?.phoneNumber === false;
  const isAllowedInSignUp = displayInSignUp === true;

  if (isDisabled || !isAllowedInSignUp) {
    return null;
  }

  const isRequired = required === true;

  // Only Swedish numbers are accepted, and they are stored as +46XXXXXXXXX.
  const phoneNumberFormatValid = validators.swedishPhoneNumberFormatValid(
    intl.formatMessage({
      id: `${formName}.phoneNumberInvalid`,
    }),
    // When the number is optional the user may leave the pre-filled "+46"
    // alone; the format check then only applies once they type digits.
    { allowEmpty: !isRequired }
  );

  const validateMaybe = {
    validate: isRequired
      ? validators.composeValidators(
          validators.required(
            intl.formatMessage({
              id: `${formName}.phoneNumberRequired`,
            })
          ),
          phoneNumberFormatValid
        )
      : phoneNumberFormatValid,
  };

  return (
    <FieldPhoneNumberInput
      className={classNames(className, { [rootClassName]: !!rootClassName })}
      type="text"
      id={formId ? `${formId}.phoneNumber` : 'phoneNumber'}
      name="phoneNumber"
      // Sign-up shows "+46" up front, so the user only types the rest.
      initialValue={SWEDISH_PHONE_PREFIX}
      label={intl.formatMessage({
        id: `${formName}.phoneNumberLabel`,
      })}
      placeholder={intl.formatMessage({
        id: `${formName}.phoneNumberPlaceholder`,
      })}
      {...validateMaybe}
    />
  );
};

UserFieldPhoneNumber.defaultProps = {
  rootClassName: null,
  className: null,
  formId: null,
};

UserFieldPhoneNumber.propTypes = {
  rootClassName: string,
  className: string,
  formId: string,
  formName: string.isRequired,
  userTypeConfig: propTypes.userType.isRequired,
  intl: intlShape.isRequired,
};

export default UserFieldPhoneNumber;
